module.exports = __webpack_public_path__ + "static/media/friday-in-spanish.ac16b1de.png";